import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

export const usePortalManifest = (portal) => {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return undefined;
    const prev = link.getAttribute("href");
    link.setAttribute("href", `/manifest-${portal}.json`);
    return () => link.setAttribute("href", prev);
  }, [portal]);
};

export const useInstallPrompt = () => {
  const [prompt, setPrompt] = useState(() => window.__rathriBIP || null);
  const [installed, setInstalled] = useState(window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); window.__rathriBIP = e; setPrompt(e); };
    const ready = () => { if (window.__rathriBIP) setPrompt(window.__rathriBIP); };
    const done = () => { setInstalled(true); window.__rathriBIP = null; };
    ready();
    window.addEventListener("beforeinstallprompt", h);
    window.addEventListener("rathri-bip", ready);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("beforeinstallprompt", h); window.removeEventListener("rathri-bip", ready); window.removeEventListener("appinstalled", done); };
  }, []);
  const install = async () => {
    const p = prompt || window.__rathriBIP;
    if (p) { p.prompt(); setPrompt(null); window.__rathriBIP = null; return; }
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    toast(ios ? "Safari-ൽ Share ബട്ടൻ → 'Add to Home Screen' തിരഞ്ഞെടുക്കുക" : "ബ്രൗസർ മെനുവിൽ (⋮) 'Install app' / 'Add to Home Screen' തിരഞ്ഞെടുക്കുക", { duration: 6000 });
  };
  return { install, installed };
};

export const InstallButton = ({ portal, label = "ആപ്പ് ഇൻസ്‌ടാൾ" }) => {
  usePortalManifest(portal);
  const { install, installed } = useInstallPrompt();
  if (installed) return null;
  return (
    <button type="button" data-testid={`${portal}-install-button`} onClick={install} title="ആപ്പ് ഇൻസ്‌ടാൾ" className="btn-accent rounded-full h-9 w-9 sm:w-auto sm:px-3 inline-flex items-center justify-center gap-1.5 text-xs font-bold whitespace-nowrap">
      <Download size={13} /> <span className="hidden sm:inline">{label}</span>
    </button>
  );
};
